import { useAppDispatch } from '../../effects/useAppDispatch';
import { createFilterActions } from '../../actions/filter.actions';
import { useAppSelector } from '../../effects/useAppSelector';
import { BwicFilterType } from '../../types/filters/FilterState';
import { PageConfigType } from '../../types/page-config/PageConfigType';
import { BwicFilters } from '../filters/BwicFilters';
import { getLoanMonitorFilters } from './filter/loanMonitorFilters';
import { SubscriptionFeature } from '../../types/billing/SubscriptionFeature';

const filterActions = createFilterActions(BwicFilterType.LoanMonitor);

interface LoanMonitorFiltersProps {
    onApply: () => void;
    disabled?: boolean;
}

export function LoanMonitorFilters({ onApply, disabled = false }: LoanMonitorFiltersProps) {
    const dispatch = useAppDispatch();
    const filter = useAppSelector(s => s.filters.loanMonitor.filter);
    const visibleFilters = useAppSelector(s => s.filters.loanMonitor.visibleFilters);
    const lastAppliedFilter = useAppSelector(s => s.filters.loanMonitor.lastAppliedFilter);
    const filterChanged = useAppSelector(s => s.filters.loanMonitor.filterChanged);
    const filterModified = useAppSelector(s => s.filters.loanMonitor.filterModified);
    const selectedFilterReferenceName = useAppSelector(s => s.filters.loanMonitor.selectedFilterReferenceName);

    const handleReset = () => {
        dispatch(filterActions.resetFiltersAndUnselectSavedFilter());
        onApply();
    };

    return (
        <BwicFilters
            filterType={BwicFilterType.LoanMonitor}
            isSearching={disabled}
            filter={filter}
            visibleFilters={visibleFilters}
            lastAppliedFilter={lastAppliedFilter}
            filterChanged={filterChanged}
            filterModified={filterModified}
            hiddenFilters={getLoanMonitorFilters().additionalFilters}
            withAlerts={false}
            filterConfigShowEmailNotification={false}
            pageConfigType={PageConfigType.LoanMonitor}
            saveFilterVisible={true}
            saveFilterBlockerFeature={SubscriptionFeature.LoanFiltersAndSearch}
            advancedFiltersBlockerFeature={SubscriptionFeature.LoanFiltersAndSearch}
            selectedFilterReferenceName={selectedFilterReferenceName}
            withBlockedSearchAndFilter={disabled}
            onApply={onApply}
            onReset={handleReset}
            onVisibilityChange={key => dispatch(filterActions.filterVisibilityChange(key))}
        />
    );
}
